"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors = {
    primary: {
        $300: "#00789A",
        $400: "#22809C",
        $500: "#29A3C5",
        $600: "#28B0D6",
        $700: "#5CB9D4"
    },
    secondary: {
        $300: "#951B7C",
        $400: "#951B7C",
        $500: "#AF3C98",
        $600: "#C82FAA",
        $700: "#CC5CB7"
    },
    success: {
        $300: "#0A5D26",
        $400: "#0D702E",
        $500: "#1A7E3B",
        $600: "#00BF3F",
        $700: "#4DA96C"
    },
    danger: {
        $300: "#820005",
        $400: "#9E2127",
        $500: "#B63338",
        $600: "#F8333C",
        $700: "#FF6B71"
    },
    warning: {
        $300: "#775D00",
        $400: "#94770E",
        $500: "#AC8E20",
        $600: "#D4A700",
        $700: "#D9BB4F"
    },
    gray: {
        $000: "#1b1b1b",
        $010: "#222222",
        $025: "#303030",
        $050: "#363636",
        $100: "#424242",
        $200: "#595959",
        $300: "#6e6e6e",
        $400: "#818181",
        $500: "#8c8c8c",
        $600: "#949494",
        $700: "#adadad",
        $800: "#d1d1d1",
        $900: "#e6e6e6"
    }
};
exports.default = colors;
//# sourceMappingURL=index.js.map